// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-radio-button__inner[data-v-4f2ae9a9] {\n  width: 100px;\n}", ""]);
// Exports
module.exports = exports;
